export const toastsContainerId = 'toasts-container'
